import I18n from 'app/i18n';

export const currencyName = (currency: string, network?: string): string => {
    if (network) {
        return `${currency} (${I18n.t('network')}: ${network})`;
    }

    return currency;
};
